






































































import { Component } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TimesheetListModule } from '@/store/modules/timesheetList';
import { AgencyModule } from '@/store/modules/agency';
import Alert from '@/components/Shared/Alert.vue'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import TimesheetStatus from '@/components/Timesheets/Display/TimesheetStatus.vue';
import InvoiceStatus from '@/components/Invoices/Display/InvoiceStatus.vue';
import JourneyDetails from '@/components/Timesheets/Display/JourneyDetails.vue';
import TimesheetListSearchCriteria from '@/components/Timesheets/TimesheetListSearchCriteria.vue';
import TimesheetListEdit from '@/components/Timesheets/TimesheetListEdit.vue';
import TimesheetStatusEnum from '@/models/Timesheets/TimesheetStatus';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue'

@Component({
	name: 'AgencyTimesheets',
  	components: { Alert, TimesheetStatus, InvoiceStatus, JourneyDetails, TimesheetListSearchCriteria, BookingRoleWorkerShiftStatus, TimesheetListEdit }
})
export default class extends GiganautVue {

	timesheetStatus = TimesheetStatusEnum

  get loading() {
		return TimesheetListModule.loading;
   }
   
  private search = '';

  get timesheets() {
    return TimesheetListModule.timesheets;
  }

  get totalDuration() {
    let sum = 0
    sum = this.timesheets.reduce((sum, current) => sum + current.shiftUnitsNet, 0);
    return sum.toFixed(2);
  }

  async approve(timesheetId: string) {
	  await TimesheetListModule.approveTimesheet(timesheetId);
  }

   private headers = [
    { text: "Desk", value: 'booking.desk.name'},
    { text: this.Labels.company, value: 'company.brandName'},
    { text: this.Labels.location, value: 'location.brandName'},
    { text: this.Labels.worker, value: 'worker.person.lastName'},
    { text: 'Date', value: 'startAt'},
    { text: 'Journey', sortable: false},
    { text: 'Booking Status', value: 'bookingRoleWorkerShift.status'},
    { text: 'Timesheet Status', value: 'status'},
    { text: 'Invoice Status', value: 'invoice.status'},
    { text: 'Actions'},
  ]
}
